import {
  getCompanyListMaster, getoutletListMaster, PaymentList
} from "../../../../apiservicescall/api";
import React, {
  Fragment,
  useState,
  useEffect,
  useRef,
  useMemo,
  useCallback,
} from "react";

import Table from "@mui/material/Table";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import MUIDataTable from "mui-datatables";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/Step";
import StepButton from "@material-ui/core/StepButton";
import RctCollapsibleCard from "../RctCollapsibleCard/RctCollapsibleCard";
import {
  // Table,
  Badge,
  Row,
  Card,
  Col,
  Button,
  Container,
  ListGroup,
  Tab,
} from "react-bootstrap";
import Select from "react-select";
import {
  Pagination,
  PaginationItem,
  PaginationLink,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { CardTitle, CardBody } from "reactstrap";
import Multiselect from "multiselect-react-dropdown";
import { List } from "@material-ui/core";
import { Payment } from "@material-ui/icons";

const ManagePaymentMethods = () => {

  const [companyMaster, setCompanyMaster] = useState([]);


  const [outletvalue, setOutletvalue] = useState([{ label: "", value: "", }]);
  const [restarantvalue, setRestarantvalue] = useState([{ label: "", value: "", }]);
  const [outletMasterlist, setOutletMasterlist] = useState([]);

  const [paymentlistmaster, setPaymentlistmaster] = useState([]);
  const [paymentfetchitem, setPaymentfetchitem] = useState([]);

  useEffect(() => {
    getcompanyMasterList();

  }, []);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [approvalpopup, setApprovalPopup] = useState(false);
  const [tempstatemaster, setTempstatemaster] = useState({});
  
  const getcompanyMasterList = useCallback(async () => {

    let getoutletList = await getCompanyListMaster();
    let getoutletListValue = getoutletList?.data?.data;
    let companyoutmaster = getoutletListValue.map(({ compCode, compName }) => ({
      label: compName,
      value: compCode,
    }));

    setCompanyMaster(companyoutmaster);
    setOutletvalue({
      label: getoutletListValue[0]?.compName,
      value: getoutletListValue[0]?.compCode,
    });
    getoutletMasterList(getoutletListValue[0]?.compCode);
  }, []);




  const getoutletMasterList = async (companyCode) => {
    let getoutletList = await getoutletListMaster(companyCode);
    let getoutletListValue = getoutletList?.data?.data;
    let companyoutmaster = getoutletListValue
      && getoutletListValue.map(({ outletCode, outletName }) => ({
        label: `${outletCode}-${outletName}`,
        value: outletCode,
      }));
    // console.log("companyoutmaster", companyoutmaster);
    setOutletMasterlist(companyoutmaster);
  };


  const getpaymentmasterlist = async (outletCode) => {
    let getslotList = await PaymentList(outletCode);
    let getslotListValue = getslotList?.data?.data || [];
    setPaymentfetchitem(getslotListValue);
    setPaymentlistmaster(getslotListValue);

    // console.log("getslotListValue",getslotListValue);
    // let searchfieldvalue = "dd";
    // let filteredMenuItemList =
    //   getslotListValue &&
    //   getslotListValue.filter(
    //     (item) =>
    //       item.itemDesc.substring(0, 1) == searchfieldvalue.substring(0, 1)
    //   );
  };


  let actionOption = {
    name: "actions",
    label: "Actions",
    options: {
      filter: false,
      sort: false,
      customBodyRender: (summary, tableMeta, updateValue) => {
        return (
          <div className="list-action">
            <span
              style={{ color: "white", display: "flex" }}
              className="icon-top-left"
            >
              {/* <button
              type="button"
              className="rct-link-btn edit-btn"
              onClick={() => onEditUser(tableMeta)}
            >
              <i style={{ fontSize: "15px" }} className="ti-pencil"></i>
            </button> */}

              {/* <Link
                className=""
                onClick={() => {
                  // setOutletDetails({})
                  approvalcall(tableMeta);
                }} */}
                {/* // style={{ background: "#008000" }} */}
              {/* >
                <i
                  className="fas fa-pencil-alt fa-lg tpen-bck"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginLeft: "1px",
                  }}
                ></i>
              </Link> */}

              {/* <Link
                className=""
                onClick={() => {
                  // setOutletDetails({})
                  viewDpoint(tableMeta);
                }}
                // style={{ background: "#008000" }}
              >
                <i
                  className="fa fa-eye tpen-bck"
                  style={{ marginLeft: "3px" }}
                ></i>
              </Link> */}
            </span>

            {/* <span style={{ paddingLeft: "20px",marginTop: "-20px" }} className="icon-top-left">

            <Link className="btn btn-primary shadow btn-xs sharp me-2"
              onClick={() => viewUser(tableMeta)} style={{ background: "#008000" }}
            >
              <i className="fa fa-eye"></i>
            </Link>
          </span> */}
          </div>
        );
      },
    },
  };

  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const onChangeRowsPerPage = (numOfRows) => {
    // let { currentPage, itemsPerPage } = this.state;
    setItemsPerPage(numOfRows);
  };
 
  const options = {
    filter: true, 
      search: true, 
      selectableRows: false,
      responsive: "stacked",
      fixedHeader: true,
      tableBodyHeight: "60vh",
      fixedSelectColumn: true,
      page: currentPage,
      pagination: true,
      serverSide: false,
      rowsPerPage: itemsPerPage,
      rowsPerPageOptions: [10, 15, 100],
      onChangePage: (newPage) => {
        handleChangePage(newPage);
      },
      onChangeRowsPerPage: (numOfRows) => {
        onChangeRowsPerPage(numOfRows);
      },
      download: false,
      print: false,
      onFilterChange: (column, filterList, type, filterOptions, changedColumnIndex) => {
        
      },
      confirmFilters: true,
      customFilterDialogFooter: (currentFilterList, applyNewFilters) => {
        return (
          <div style={{ marginTop: "40px" }}>
            <Button
              variant="contained"
              onClick={() => applyNewFilters()} 
            >
              Apply Filters
            </Button>
          </div>
        );
      },
      onFilterConfirm: (filterList) => {
        // Handle filter confirmation here if needed
      },
      onFilterDialogOpen: () => {
        // Handle filter dialog open event if needed
      },
      onFilterDialogClose: () => {
        // Handle filter dialog close event if needed
      },
    customToolbar: () => {
      return (
        <>
          {
            // <>
            //   {largeModal ? (
            //     <a
            //       href="#"
            //       style={{ backgroundColor: "#008000", color: "white" }}
            //       onClick={(e) => opnAddNewUserModal(e)}
            //       className="caret btn-sm mr-10"
            //     >
            //       ADD <i className="zmdi zmdi-lus"></i>
            //     </a>
            //   ) : (
            //     <a
            //       href="#"
            //       style={{
            //         backgroundColor: "#008000",
            //         color: "white",
            //         fontSize: "medium",
            //       }}
            //       onClick={(e) => {
            //         opnAddNewUserModal(e);
            //         setCustomerDetail({});
            //       }}
            //       className="caret btn-sm mr-10"
            //     >
            //       Add <i className="zmdi zmdi-lus"></i>
            //     </a>
            //   )}
            // </>
          }
        </>
      );
    },
  };

  const columns = [
    {
      name: "itemName",
      label: "Item Name",
      options: {
        filter: true,
        sort: true,
        searchable: true, 
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },

    {
      name: "categoryName",
      label: "Category",
      options: {
        filter: true,
        sort: true,
        searchable: true, 
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },

    {
      name: "subCategoryName",
      label: "Sub Category ",
      options: {
        filter: true,
        sort: true,
        searchable: true, 
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },  

    actionOption,
  ];
  const themeTable = createMuiTheme({
    overrides: {
      MUIDataTable: {
        root: {
          backgroundColor: "#FF000",
        },
        paper: {
          boxShadow: "none",
        },
      },
      MuiTableRow: {
        root: {
          "&:nth-of-type(odd)": {
            backgroundColor: "white !important",
          },
          "&:nth-of-type(even)": {
            backgroundColor: "#e4e8ef !important",
          },
        },
      },

      MUIDataTableHeadCell: {
        root: {
          backgroundColor: "#008000 !important",
        },
        data: {
          fontWeight: "bold",
          color: "white",
          fontSize: "14px",
        },
      },
    },
  });


  return (
    <>
      <div className="row">
      <div className="col-md-12 col-lg-12 col-sm-12 col-xl-12">
        <Card>
          <div class="row">
           <div class="col-3 col-md-3 col-lg-3">
               <div class="form-group">
              <h3 className="me-auto  main-hd">
                Payment
              </h3>
              </div>
            </div>
            <div class="col-7 col-md-7 col-lg-7 row">
             <Card.Header className="card-title  main-card">
             <div class="col-4 col-md-4 col-lg-4 form-group main-frm-grp" style={{width:"40%"}} >
              <label as="a" variant="badge badge-rounded badge-danger">
                Company
              </label>
              <Select
                options={companyMaster}
                value={outletvalue}
                closeMenuOnSelect={false}
                search
                styles={{zIndex:"800"}}
                name="stateCode"
                placeholder="Choose"
                autoComplete="off"
                onChange={(event) => {

                  setRestarantvalue({ label: "", value: "" });
                  setOutletvalue(event);
                  console.log("Outletvalue",event);
                  getoutletMasterList(event?.value);
                  setPaymentfetchitem([]);
                }}
              />
            </div>

            <div class="col-4 col-md-4 col-lg-4 form-group main-frm-grp" style={{ width:"39%", zIndex:"800" }}>
              <label as="a" variant="badge badge-rounded badge-danger">
                Restaurant
              </label>
              <Select
              styles={{zIndex:"800"}}
                options={outletMasterlist}
                value={restarantvalue}
                closeMenuOnSelect={false}
                search
                name="stateCode"
                placeholder="Choose"
                autoComplete="off"
                onChange={(event) => {
                  setRestarantvalue(event);
                  getpaymentmasterlist(event?.value)
                  // console.log(" getpaymentmasterlist", getpaymentmasterlist);
                }}
              />
            </div>
          </Card.Header>
          </div>
          </div>
          <Card.Body className="scroll-tbl-fix-header"  style={{ padding: "0.875rem" }}>
            {/* <input
           type="text" placeholder="Search Menu item/tag"
           style={{
             marginBottom: "14px",
             marginLeft: "400px",
             border: "2px solid #3abd4a", borderRadius: "12px", padding: "5px",

           }}
       //     onChange={(e) => {
       //       searchFilterMenuListMaster(e.target.value);
       //     }}
          /> */}
 <RctCollapsibleCard fullBlock>
              <RctCollapsibleCard fullBlock>
                <MuiThemeProvider theme={themeTable}>
                  <MUIDataTable
                    title={""}
                    data={outletMasterlist}
                    columns={columns}
                    options={options}
                    columOrder={columns}
                    className={"MuiTabCusCls"}
                  />
                </MuiThemeProvider>
              </RctCollapsibleCard>
            </RctCollapsibleCard>
            {/* <Table responsive stripped>
              <br />
              <thead>
                <tr>
                  <th>
                    <strong>Payment Id </strong>
                  </th>
                  <th>
                    <strong>Payment Method</strong>
                  </th>

                  <th>
                    <strong>Payment Status</strong>
                  </th>

                  <th>
                    <strong>Action</strong>
                  </th>
                </tr>
              </thead>
              <tbody>
                {paymentfetchitem &&
                  paymentfetchitem.map((items) => {
                    return (
                      <>
                        <tr>
                          <td>{items.paymentId}</td>
                          <td>{items.paymentMethodName}</td>

                          <td>{items.paymentStatus}</td>





                        </tr>
                      </>
                    );
                  })}

                {paymentfetchitem?.length <= 0 ? (
                  <div style={{ color: "red", textAlign: 'center' }}> No Data Found </div>
                ) : setPaymentfetchitem}
              </tbody>


            </Table> */}
          </Card.Body>

          
        </Card>

      </div> 
      </div> </>
    

  )
}

export default ManagePaymentMethods